import React from 'react';
import { Filter, Grid, Map as MapIcon, ArrowDownAZ } from 'lucide-react';
import { FilterState, LocationCategory, ViewMode } from '../types';

interface FiltersProps {
  filters: FilterState;
  viewMode: ViewMode;
  onFilterChange: (filters: FilterState) => void;
  onViewModeChange: (mode: ViewMode) => void;
}

export const Filters: React.FC<FiltersProps> = ({ filters, viewMode, onFilterChange, onViewModeChange }) => {
  const categories: { value: LocationCategory | 'all'; label: string }[] = [
    { value: 'all', label: 'Усе' },
    { value: 'eco-trail', label: 'Экасцежкі' },
    { value: 'camping', label: 'Кемпінг' },
    { value: 'stargazing', label: 'Назіранне за зоркамі' },
    { value: 'picnic', label: 'Пікнік' },
    { value: 'eco-hotel', label: 'Экаатэль' },
    { value: 'estate', label: 'Сядзіба' },
    { value: 'zoo', label: 'Звярынцы' },
    { value: 'Historical places', label: 'Гістарычныя месцы' },
    { value: 'other', label: 'Іншае' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 mb-8">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Category Filter */}
        <div className="relative flex-1">
          <Filter size={20} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primary" />
          <select
            className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-transparent rounded-full focus:outline-none focus:border-primary focus:bg-white appearance-none transition-colors"
            value={filters.category}
            onChange={(e) => onFilterChange({ ...filters, category: e.target.value as LocationCategory | 'all' })}
          >
            {categories.map((category) => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        {/* Sort By */}
        <div className="relative flex-1">
          <ArrowDownAZ size={20} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primary" />
          <select
            className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-transparent rounded-full focus:outline-none focus:border-primary focus:bg-white appearance-none transition-colors"
            value={filters.sortBy}
            onChange={(e) => onFilterChange({ ...filters, sortBy: e.target.value as FilterState['sortBy'] })}
          >
            <option value="distance">Па адлегласці</option>
            <option value="newest">Спачатку новыя</option>
            <option value="popular">Найбольш папулярныя</option>
            <option value="rating">З высокай ацэнкай</option>
          </select>
        </div>

        {/* Distance Slider */}
        <div className="flex items-center gap-4 bg-gray-50 px-4 py-3 rounded-full flex-1">
          <input
            type="range"
            min="0"
            max="800"
            step="10"
            value={filters.radius}
            onChange={(e) => onFilterChange({ ...filters, radius: Number(e.target.value) })}
            className="flex-1 accent-primary"
          />
          <span className="text-sm text-gray-600 min-w-[5.5rem] text-right">
            {filters.radius === 800 ? 'Уся Беларусь' : `${filters.radius} км`}
          </span>
        </div>

        {/* View Mode Toggle */}
        <div className="flex gap-2 bg-gray-100 p-1 rounded-full sm:flex-none">
          <button
            onClick={() => onViewModeChange('list')}
            className={`flex-1 sm:flex-none px-4 py-2 rounded-full flex items-center justify-center gap-2 transition-colors ${
              viewMode === 'list' ? 'bg-white shadow-sm' : 'hover:bg-white/50'
            }`}
          >
            <Grid size={20} />
            <span>Плітка</span>
          </button>
          <button
            onClick={() => onViewModeChange('map')}
            className={`flex-1 sm:flex-none px-4 py-2 rounded-full flex items-center justify-center gap-2 transition-colors ${
              viewMode === 'map' ? 'bg-white shadow-sm' : 'hover:bg-white/50'
            }`}
          >
            <MapIcon size={20} />
            <span>Карта</span>
          </button>
        </div>
      </div>
    </div>
  );
};